var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2665",
    "data-name": "Group 2665",
    transform: "translate(-810 -391.775)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(810 391.775)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M-17.383-4036.766a.291.291,0,0,1-.291-.291v-2.036h-2.036a.291.291,0,0,1-.291-.291.291.291,0,0,1,.291-.291h2.036v-2.036a.291.291,0,0,1,.291-.291.291.291,0,0,1,.291.291v2.036h2.036a.291.291,0,0,1,.291.291.291.291,0,0,1-.291.291h-2.036v2.036A.291.291,0,0,1-17.383-4036.766Z",
    transform: "translate(833.383 4437.158)",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd56);
export default __webpack_public_path__ + "static/media/add56.f5cb30299004243400f77b7c8a1c89d2.svg";
export { ForwardRef as ReactComponent };